module.exports = __webpack_public_path__ + "img/cowork.190bdc14.svg";